import { render, staticRenderFns } from "./TokenAddDialog.vue?vue&type=template&id=75c08d7b"
import script from "./TokenAddDialog.vue?vue&type=script&lang=js"
export * from "./TokenAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports